import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Select from "react-select";
import ModalLayout from "../Layout/ModalLayout";
import VehicleDetails from "../Vehicle/VehicleDetails";
import VehicleImage, { imgValidation } from "../Vehicle/VehicleImage";
import { initialVhclData } from "../Vehicle/VehicleMain";
import VehicleInfo from "../Vehicle/VehicleInfo";
import {
  DATE_FORMAT_CLIENT,
  DATE_FORMAT_SERVER,
  REQUIRED_ERR_MSG,
  TWO_DECIMAL,
} from "../Helper/Constants";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import GetSvgIcon from "../../images/svglist";
import { DownloadFile } from "../Helper/FileStoreService";
import {
  numberInputOnWheelPreventChange,
  permission,
  toBase64,
} from "../Helper/CommonMethods";
import { getUserInfo } from "../AuthUtils/AuthUtils";
import {
  APPROVE_APRVL,
  LEASEAPVL,
  PENDING_APRVL,
  REJECT_APRVL,
  VHCLLEASEFIN,
  VHCLLEASEREQ,
} from "../../ConfigConstants/ConfigConstants";

const VehicleLeaseAddEdit = ({
  modalConfig,
  handleModalClose,
  onSave,
  vhclOpts,
  avlPtr,
  fetchVhclInfos,
  vhclData,
  setVhclInfo,
  selVhclLease,
  handleOnClick,
  getApprovalHistory,

  // isFinAllowed,
}) => {
  const userRoles = JSON.parse(getUserInfo("userRoles"));
  const [cleanUpData, setCleanUpData] = useState(new Date());
  const {
    control,
    register,
    setValue,
    setError: vSetError,
    reset,
    getValues,
    watch,
    clearErrors: vClearErrors,
    formState: { isDirty, errors: vErrors },
    handleSubmit: vHandleSubmit,
  } = useForm();
  const {
    control: lControl,
    handleSubmit,
    register: lRegister,
    formState: { errors, isDirty: lIsDirty },
    reset: lReset,
    watch: lWatch,
    setError,
    clearErrors: lClearErrors,
    setValue: lSetValue,
    getValues: lGetValues,
  } = useForm();
  const {
    fields: vhclInfoArr,
    update,
    replace,
  } = useFieldArray({
    control,
    name: "vhclInfos",
  });

  const watchRoleId = lWatch("approverRole");
  const watchVhclId = lWatch("vhclId");
  const watchApprovalId = lWatch("approvalStepId");
  const watchApprovalStaus = lWatch("statusId");
  const isFinAllowed =
    permission(VHCLLEASEFIN)?.allowedWrite &&
    userRoles.some((r) => r.roleId === watchRoleId);
  const watchAttachment = lWatch("attachment");
  const watchLeaseId = lWatch("id");

  useEffect(() => {
    reset(vhclData);
  }, [vhclData]);

  useEffect(() => {
    let copySelLease = Object.assign({}, selVhclLease);
    copySelLease.attachment = JSON.parse(copySelLease.attachment);
    lReset(copySelLease);
    if (copySelLease.vhclId > 0) {
      fetchVhclInfos(copySelLease.vhclId);
    }
  }, [selVhclLease]);
  const watchValidFrom = lWatch("startDate");
  const watchValidTo = lWatch("endDate");

  const onError = (err) => {
    console.error(err);
  };
  const handleAction = (argTitle, argActionCode, data) => {
    let entity = Object.assign({}, data);
    entity.title = argTitle;
    entity.approvalStatus = argActionCode;
    entity.update = lIsDirty;
    const payload = {
      leaseDto: entity,
      logDto: entity,
    };
    if (argActionCode === APPROVE_APRVL && isFileAvl(data.attachment)) {
      handleOnClick(payload);
    } else if (argActionCode === REJECT_APRVL) {
      handleOnClick(payload);
    } else {
      setError("attachment", { type: "required", message: REQUIRED_ERR_MSG });
    }
  };

  const isFileAvl = (file) => {
    let valid = true;
    if (isFinAllowed && !file.photoFileName) {
      valid = false;
    }
    return valid;
  };

  const validateAttachments = (vData) => {
    let isValid = true;
    const copyVehInfos = vData.vhclInfos;
    copyVehInfos.forEach((element, index) => {
      if ([null, undefined, ""].includes(element.attachment1.photoFileName)) {
        vSetError(`vhclInfos.${index}.attachment1`, {
          type: "required",
          message: REQUIRED_ERR_MSG,
        });
        isValid = false;
      }
    });
    const isVhclImgValid = imgValidation(vData, vSetError);
    // isValid = imgValidation(vData, vSetError);
    return isValid && isVhclImgValid;
  };

  const onLeaseRequest = (vData) => {
    if (validateAttachments(vData)) {
      setValue("partnerId", 0);
      let tVhclLease = lGetValues();
      tVhclLease.update = lIsDirty;
      vData.update = isDirty;
      const payload = {
        vhclLease: tVhclLease,
        vhclDto: vData,
      };
      if (
        tVhclLease?.attachment.photo !== null &&
        tVhclLease?.attachment.photoFileName !== null
      ) {
        onSave(payload);
      } else {
        setError("attachment", { type: "required", message: REQUIRED_ERR_MSG });
      }
    }
  };

  const onVehError = (err) => {
    console.error(err);
  };

  const handleRequestToLease = async (data) => {
    // setValue("partnerId", 0);
    // data.update = lIsDirty;
    // let vehData = getValues();
    // vehData.update = isDirty;
    // const payload = {
    //   vhclLease: data,
    //   vhclDto: vehData,
    // };
    // const isVhclDataValid = await trigger();
    // if (isVhclDataValid) {
    //   onSave(payload);
    // } else {
    //   console.error(vErrors);
    // }
    vHandleSubmit(onLeaseRequest, onVehError)();
  };

  const approveAction = () => {
    const data = lGetValues();
    handleAction("Reject Approval Request", REJECT_APRVL, data);
  };

  const footerbtn = (
    <div className="d-flex justify-content-center w-100 m-0">
      {watchApprovalId > 0 ? (
        <>
          {userRoles.some((r) => r.roleId === watchRoleId) &&
            watchApprovalStaus === PENDING_APRVL &&
            permission(LEASEAPVL)?.allowedWrite && (
              <>
                <Button variant="danger" onClick={approveAction}>
                  Reject
                </Button>
                <Button
                  className="theme-violet ms-1"
                  onClick={handleSubmit(
                    (data) =>
                      handleAction(
                        "Approve Lease Request",
                        APPROVE_APRVL,
                        data
                      ),
                    onError
                  )}
                >
                  Approve
                </Button>
              </>
            )}
        </>
      ) : (
        watchLeaseId === 0 &&
        permission(VHCLLEASEREQ)?.allowedWrite && (
          <Button
            variant="primary"
            className="theme-violet"
            onClick={handleSubmit(handleRequestToLease, onError)}
          >
            Request To Lease
          </Button>
        )
      )}
    </div>
  );
  const selectFile = async (key, event, code) => {
    const file = event.target.files;
    if (file.length === 0) {
      const newAttachment = {
        photo: "",
        photoFileName: "",
        photoFileType: "",
        photoBucketUrl: "",
      };

      if (!isFinAllowed) {
        lSetValue(key, newAttachment, { shouldDirty: true });
      } else {
        lSetValue(key, newAttachment);
      }
    } else {
      lClearErrors("attachment");
      var fileName = file[0].name;
      var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
      var photo = "";
      try {
        photo = await toBase64(file[0]);
      } catch (error) {
        console.error(error);
      }
      const attachmentName = `${code}-${moment().format("YYYYMMDDHHmmss")}`;
      const newAttachment = {
        photo: photo,
        photoFileName: attachmentName,
        photoFileType: ext,
        photoBucketUrl: "",
      };
      lSetValue(key, newAttachment, { shouldDirty: true });
    }
  };

  const loadVhclData = (opt) => {
    if (!!opt) {
      fetchVhclInfos(opt.value);
    } else {
      setVhclInfo(Object.assign({}, initialVhclData));
      setCleanUpData(new Date());
    }
  };
  const postDownload = () => {
    alert("File Downloaded Successfully!");
  };

  return (
    <ModalLayout
      moadlConfig={modalConfig}
      handleMoalClose={handleModalClose}
      footer={footerbtn}
    >
      <Row>
        <Col>
          {selVhclLease.statusId === 37 &&
            userRoles.some((r) => r.roleId === selVhclLease.approverRole) &&
            selVhclLease.checklist && (
              <div className="alert alert-info">
                <div>
                  <div className="float-start">
                    <h5 className="card-title">Approval Checklist</h5>
                    <p className="card-text">{selVhclLease.checklist}</p>
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>
            )}
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="form-label theme-label">
            {+watchLeaseId > 0 ? "Vehicle" : "Choose a Vehicle"}{" "}
            <span className="text-danger">&#9733;</span>
          </label>
          {+watchLeaseId > 0 ? (
            <input
              name="vhclNo"
              className="form-control"
              {...register("vhclNo")}
              disabled
            />
          ) : (
            <Controller
              name="vhclId"
              control={lControl}
              rules={{
                required: {
                  value: true,
                  message: "This field is required!!",
                },
                min: { value: 1, message: "This field is required!!" },
              }}
              render={({ field: { onChange, value } }) => (
                <Select
                  placeholder="Select Vehicle"
                  isSearchable={true}
                  isClearable={true}
                  className="form-control p-0"
                  options={vhclOpts}
                  value={
                    !!value
                      ? vhclOpts?.find((opt) => opt.value === value)
                      : value
                  }
                  // onChange={(opt) => onChange(!!opt ? opt.value : 0)}
                  onChange={(opt) => {
                    onChange(!!opt ? opt.value : 0);
                    loadVhclData(opt);
                  }}
                  isDisabled={+watchApprovalId > 0}
                />
              )}
            />
          )}
          {errors?.vhclId && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888; {errors?.vhclId?.message}
              </span>
            </div>
          )}
        </Col>
        <Col>
          <label className="form-label theme-label">
            Leasing To <span className="text-danger">&#9733;</span>
          </label>
          <Controller
            name="prtId"
            control={lControl}
            rules={{
              required: {
                value: true,
                message: "This field is required!!",
              },
              min: { value: 1, message: "This field is required!!" },
            }}
            render={({ field: { onChange, value } }) => (
              <Select
                placeholder="Leasing To"
                isSearchable={true}
                isClearable={true}
                className="form-control p-0"
                options={avlPtr}
                value={
                  !!value ? avlPtr?.find((opt) => opt.value === value) : value
                }
                onChange={(opt) => onChange(!!opt ? opt.value : 0)}
                isDisabled={+watchApprovalId > 0}
              />
            )}
          />
          {errors?.prtId && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888; {errors?.prtId?.message}
              </span>
            </div>
          )}
        </Col>
        {watchLeaseId === 0 && permission(VHCLLEASEREQ)?.allowedWrite ? (
          <Row>
            <Col>
              <label className="form-label theme-label">
                Agreement <span className="text-danger">&#9733;</span>
              </label>
              <div>
                <div
                  className={"theme-violet-txt d-flex align-items-center"}
                  // className="theme-violet-txt d-flex align-items-center"
                >
                  <span
                    type="button"
                    className="position-relative d-inline-block cursor-pointer"
                  >
                    <input
                      type="file"
                      className="position-absolute w-100 h-100 top-0 start-0 opacity-0 cursor-pointer"
                      aria-describedby="button-addon2"
                      accept="application/pdf, image/jpeg, image/jpg"
                      id={"attachment"}
                      onChange={(e) => selectFile("attachment", e, "AGREEMENT")}
                      title={
                        watchAttachment?.photoFileName?.length > 0
                          ? watchAttachment?.photoFileName
                          : "No File Choosen"
                      }
                    />
                    <span className="cursor-pointer">
                      {GetSvgIcon("BiFileEarmarkMed")}
                    </span>
                  </span>
                  <span
                    type="button"
                    className={
                      watchAttachment?.photoBucketUrl?.length > 0
                        ? "text-primary ps-1"
                        : "text-black ps-1"
                    }
                    disabled={watchAttachment?.photoBucketUrl?.length === 0}
                    onClick={() =>
                      DownloadFile(
                        watchAttachment?.photoBucketUrl,
                        postDownload
                      )
                    }
                    title={
                      watchAttachment?.photoBucketUrl?.length > 0
                        ? "Download - " + watchAttachment?.photoBucketUrl
                        : ""
                    }
                  >
                    {GetSvgIcon("BiArrowDown")}
                  </span>
                </div>
                <span className="text-truncate">
                  <p className="m-0">
                    {watchAttachment?.photoFileName?.length > 0 &&
                      watchAttachment?.photoFileName}
                  </p>
                </span>
              </div>
              {errors?.attachment && (
                <div>
                  <span className="badge bg-danger">
                    &#9888; {errors?.attachment?.message}
                  </span>
                </div>
              )}
            </Col>
          </Row>
        ) : (
          <Col>
            <label className="form-label theme-label">
              Agreement{" "}
              {isFinAllowed && <span className="text-danger">&#9733;</span>}
            </label>
            <div>
              <div
                className={
                  isFinAllowed
                    ? "theme-violet-txt d-flex align-items-center"
                    : "theme-gray-txt d-flex align-items-center"
                }
                // className="theme-violet-txt d-flex align-items-center"
              >
                <span
                  type="button"
                  className="position-relative d-inline-block cursor-pointer"
                >
                  <input
                    type="file"
                    className="position-absolute w-100 h-100 top-0 start-0 opacity-0 cursor-pointer"
                    aria-describedby="button-addon2"
                    accept="application/pdf, image/jpeg, image/jpg"
                    id={"attachment"}
                    onChange={(e) => selectFile("attachment", e, "AGREEMENT")}
                    title={
                      watchAttachment?.photoFileName?.length > 0
                        ? watchAttachment?.photoFileName
                        : "No File Choosen"
                    }
                    disabled={!isFinAllowed}
                  />
                  <span className="cursor-pointer">
                    {GetSvgIcon("BiFileEarmarkMed")}
                  </span>
                </span>
                <span
                  type="button"
                  className={
                    watchAttachment?.photoBucketUrl?.length > 0
                      ? "text-primary ps-1"
                      : "text-black ps-1"
                  }
                  disabled={watchAttachment?.photoBucketUrl?.length === 0}
                  onClick={() =>
                    DownloadFile(watchAttachment?.photoBucketUrl, postDownload)
                  }
                  title={
                    watchAttachment?.photoBucketUrl?.length > 0
                      ? "Download - " + watchAttachment?.photoBucketUrl
                      : ""
                  }
                >
                  {GetSvgIcon("BiArrowDown")}
                </span>
              </div>
              <span className="text-truncate">
                <p className="m-0">
                  {watchAttachment?.photoFileName?.length > 0 &&
                    watchAttachment?.photoFileName}
                </p>
              </span>
            </div>
            {errors?.attachment && (
              <div>
                <span className="badge bg-danger">
                  &#9888; {errors?.attachment?.message}
                </span>
              </div>
            )}
          </Col>
        )}
      </Row>
      {+watchApprovalId > 0 && (
        <>
          <Row className="mt-1">
            <Col>
              <label className="form-label theme-label">
                Monthly Lease Price{" "}
                {isFinAllowed && <span className="text-danger">&#9733;</span>}
              </label>
              <input
                type="number"
                className="form-control"
                name="leasingPrice"
                placeholder="Enter Amount"
                disabled={!isFinAllowed}
                {...lRegister("leasingPrice", {
                  required: {
                    value: isFinAllowed,
                    message: "This field is required",
                  },
                  pattern: {
                    value: TWO_DECIMAL,
                    message: "Enter Valid Amount!!!",
                  },
                  min: {
                    value: isFinAllowed,
                    message: "This field is required",
                  },
                })}
                onWheel={(e) => numberInputOnWheelPreventChange(e)}
              />
              {errors?.leasingPrice && (
                <div>
                  <span className="badge bg-danger">
                    &#9888; {errors?.leasingPrice?.message}
                  </span>
                </div>
              )}
            </Col>
            <Col>
              <label className="form-label theme-label">
                Start Date{""}
                {isFinAllowed && <span className="text-danger">&#9733;</span>}
              </label>
              <div>
                <Controller
                  name="startDate"
                  control={lControl}
                  rules={{
                    required: {
                      value: isFinAllowed,
                      message: REQUIRED_ERR_MSG,
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <ReactDatePicker
                      placeholderText="Start Date"
                      wrapperClassName="w-100"
                      className="form-control"
                      dateFormat={DATE_FORMAT_CLIENT}
                      selected={value ? new Date(value) : value}
                      minDate={new Date()}
                      maxDate={
                        !!watchValidTo ? new Date(watchValidTo) : watchValidTo
                      }
                      onChange={(d) =>
                        onChange(!!d ? moment(d).format(DATE_FORMAT_SERVER) : d)
                      }
                      disabled={!isFinAllowed}
                    />
                  )}
                />
                {errors?.startDate && (
                  <div>
                    <span className="badge bg-danger">
                      &#9888; {errors?.startDate?.message}
                    </span>
                  </div>
                )}
              </div>
            </Col>
            <Col>
              <label className="form-label theme-label">
                End Date{""}
                {isFinAllowed && <span className="text-danger">&#9733;</span>}
              </label>
              <div>
                <Controller
                  name="endDate"
                  control={lControl}
                  rules={{
                    required: {
                      value: isFinAllowed,
                      message: REQUIRED_ERR_MSG,
                    },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <ReactDatePicker
                      placeholderText="End Date"
                      wrapperClassName="w-100"
                      className="form-control"
                      dateFormat={DATE_FORMAT_CLIENT}
                      selected={value ? new Date(value) : value}
                      minDate={
                        !!watchValidFrom ? new Date(watchValidFrom) : new Date()
                      }
                      onChange={(d) =>
                        onChange(!!d ? moment(d).format("YYYY-MM-DD") : d)
                      }
                      disabled={!isFinAllowed}
                    />
                  )}
                />
                {errors?.endDate && (
                  <div>
                    <span className="badge bg-danger">
                      &#9888; {errors?.endDate?.message}
                    </span>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </>
      )}

      <div className="fw-bold my-2 theme-violet-txt border-bottom">
        Vehicle Details
      </div>
      <VehicleDetails vhclData={vhclData} />
      <div className="fw-bold my-2 theme-violet-txt border-bottom">
        Vehicle Images
      </div>
      <VehicleImage
        vhcl={vhclData}
        cleanUpData={cleanUpData}
        register={register}
        setValue={setValue}
        isReadOnly={+watchApprovalId > 0}
        isMandatory={true}
        errors={vErrors}
        clearErrors={vClearErrors}
        setError={vSetError}
      />

      <VehicleInfo
        vhclData={vhclData}
        vhclInfoArr={vhclInfoArr}
        control={control}
        register={register}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
        replace={replace}
        update={update}
        isReadOnly={+watchApprovalId > 0}
        isMandatory={true}
        errors={vErrors}
        clearErrors={vClearErrors}
      />
      {/* <ApprovalLogList data={approvalHistoryData} /> */}
    </ModalLayout>
  );
};

export default VehicleLeaseAddEdit;
